export default "__VITE_ASSET__WySIBPgs__"